<template>
    <div oncontextmenu="return false" :class="item.selected ? 'card feature-card card-border' : 'card feature-card'" v-if="item" @click.stop="toggle(item)" @click.stop.right="toggle(item)">
        <div class="d-flex justify-space-between mb-3">
            <div>
                <img oncontextmenu="return false" src="@/assets/ic-check-empty@2x.png" @click.stop="toggle(item)" @click.stop.right="toggle(item)" v-if="!item.selected" alt="">
                <img oncontextmenu="return false" src="@/assets/ic-check-filled@2x.png" @click.stop="toggle(item)" @click.stop.right="toggle(item)" v-if="item.selected" alt="">
            </div>
            <div>   
                <p class="text-uppercase grey--text mt-2 date">{{getMonthAndYear(item.due_date)}}</p>
            </div>
        </div>
        <div class="items mb-3">
            <div class="items-list" no-gutters>
                <div class="d-flex justify-space-between py-1">
                    <p class="title">Valor Inicial</p>
                    <p class="value">R${{formatNumberReal(item.value_init)}}</p>
                </div>
            </div>
            <div class="items-list" no-gutters>
                <div class="d-flex justify-space-between py-1">
                    <p class="title">Juros</p>
                    <p class="value">R${{formatNumberReal(item.value_up - item.value_init)}}</p>
                </div>
            </div>
            <div class="items-list" no-gutters>
                <div class="d-flex justify-space-between py-1">
                    <p class="title">Vencimento original</p>
                    <p class="value">{{getDateAndMonth(item.due_date)}}</p>
                </div>
            </div>
            <div class="items-list" no-gutters>
                <div class="d-flex justify-space-between py-1">
                    <p class="title">CEP</p>
                    <p class="value">{{item.address.zipcode}}</p>
                </div>
            </div>
        </div>
        <v-row class="card-footer">
            <v-col cols="6" class="pl-10">
                <v-btn @click.stop="toggle(item)"  outlined :color="!hasExpiredDate ? 'green' : 'red' " rounded>{{!hasExpiredDate ? 'A Vencer' : 'Vencida'}}</v-btn>
            </v-col>
            <v-col cols="6" class="text-right pr-3">
                <h3 :class="item.selected ? 'price secondary--text' : 'price'">R$ {{formatNumberReal(item.value_up)}}</h3>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {getMonthAndYear,getDateAndMonth, getDateIsBefore} from "@/services/date.service"
import {formatNumberReal} from "@/services/formatNumber.service"

export default {
    name: "Feature",
    props: {
        item: {
            type: Object,
            default: null
        },
    },
    data () {
        return {
            getMonthAndYear,
            getDateAndMonth,
            formatNumberReal,
            hasExpiredDate: false
        }
    },
    methods: {
        toggle(item) {
            if(item.bank_number === 0) {
                this.$emit('dialogInformation')
            }

            this.$emit('select', item)
        }
    },
    beforeMount () {
        this.hasExpiredDate = getDateIsBefore(this.item.due_date)
    }
}
</script>

<style scoped>
.feature-card {
    height: 356px !important;
    width: 312px !important;
    position: relative;
}
.card-border {
    border: 4px solid #0CCCA6;
}
.card-footer {
    position: absolute;
    width: 100%;
    bottom: 15px;
    left: 0;
}
.items-list {
    border-bottom: 2px solid rgba(22, 33, 45, 0.12);
}
.items-list:last-of-type {
    border-bottom: 0 !important;
}

.date {
    font-style: normal;
    font-weight: 600;
    font-size: 21px;
    line-height: 26px;
}

.title, .value {
    margin: 0;
    font-size: 16px !important;
    color: rgba(22, 33, 45, 0.6);
    font-weight: 600;
}
.value {
    color: rgba(22, 33, 45, 1)
}

.price {
    font-size: 18px;
    color: rgba(22, 33, 45, 0.32);
    font-weight: 600;
}
</style>